module.exports = __webpack_public_path__ + "img/Barter.e0855cf4.png";